import { Checkbox, Label, Panel, SelectionType, TableRowDisplayEvent, Image, Button, ClickEvent, DataSource, TableSelectionEvent, BlurEvent, ValidationResult, Textbox, DataSourceMode, Layout, ScreenStack, SlideoutDecorator, TableRow } from "@mcleod/components";
import { AutogenLayoutMultiSendLoadTender } from "./autogen/AutogenLayoutMultiSendLoadTender";
import { EmailUtil, ModelRow, ModelSearchResult, StringUtil } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { TextboxValidator } from "@mcleod/components/src/components/textbox/TextboxValidator";

export class MultiSendLoadTender extends AutogenLayoutMultiSendLoadTender {
    sendSelectedButton: Button;
    sourceSendTenders: DataSource;
    payee_id: String;
    override onLoad(): void {
        this.textboxContact.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.emailDomainValidator(this.textboxContact, mode);
        };
        this.textboxAddContact.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
            return this.emailDomainValidator(this.textboxAddContact, mode);
        };

    }

    private emailDomainValidator(textbox: Textbox, mode: DataSourceMode) {
        if (mode === DataSourceMode.SEARCH) {
            return null;
        }
        const result: ValidationResult = { isValid: true, component: textbox, validationMessage: null };
        const domains = textbox.text.split(",");
        for (const domain of domains) {
            if (!StringUtil.isEmptyString(domain) && !EmailUtil.isValidEmail(domain)) {
                return { component: textbox, isValid: false, validationMessage: "Invalid domain format. Email domains must be in the following format [abc.com,xyz.com]" }
            }
        }
        return null
    }

    previewLoadTenders(multiRateConProps: any[], payee_id: string) {
        this.payee_id = payee_id;
        this.sourceMultiPrepareTender.search({ movements: multiRateConProps, payee_id }).then((response: ModelSearchResult) => {
            this.setOverrideData(response.summaryData);
        });
    }

    setOverrideData(summaryData: ModelRow) {
        this.sourceMultiSendTenders.createBlankRow().then(row => {
            row.setValues(summaryData.data);
            this.sourceMultiSendTenders.setRowsAndMode(DataSourceMode.NONE, [row]);
            this.textboxMustRespondBy.displayData(this.sourceMultiSendTenders.activeRow, null, 0);
            this.textboxContact.displayData(this.sourceMultiSendTenders.activeRow, null, 0);
        })
    }

    tableMultiSendLoadTenderOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const checkbox = tableRow.findComponentById("checkboxSelectRow") as Checkbox;
        if (!modelRow.get("is_valid")) {
            const imageDisqualified = tableRow.findComponentById("imageDisqualified") as Image;
            checkbox.enabled = false;
            if (imageDisqualified) {
                imageDisqualified.visible = true;
                imageDisqualified.tooltipDynamicContent = () => {
                    return { text: "Movement is not valid to send Load Tenders", fontSize: "small", fontBold: true };
                }
            }
        }
        else {
            this.tableMultiSendLoadTender.selectRow(tableRow, SelectionType.DISTINCT, null);
        }
    }

    tableMultiSendLoadTenderOnSelect(event: TableSelectionEvent) {
        this.updateTitleNumbers();
    }

    updateTitleNumbers() {
        this.labelTotalCount.text = this.tableMultiSendLoadTender.selectedRows.length.toString();
        this.labelErrorCount.text = this.tableMultiSendLoadTender.rows.filter(row => row.enabled == false).length.toString();
        if (this.tableMultiSendLoadTender.selectedRows.length == 0) {
            this.sendSelectedButton.enabled = false;
            this.sendSelectedButton.disabledTooltip = "You must select at least one movement to send a tender for.";
        }
        else {
            this.sendSelectedButton.enabled = true;
        }
    }

    buttonSendSelectedTendersOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        if (this.tableMultiSendLoadTender.selectedRows.length === 0) {
            CommonDialogs.showMessage("Please select at least one movement to send.");
            button.busy = false;
            return;
        }
        if (TextboxValidator.validate(this.textboxContact, true, false).isValid && TextboxValidator.validate(this.textboxAddContact, true, false).isValid) {
            const rowsToSearch = this.tableMultiSendLoadTender.selectedRows.map(row => {
                return {
                    ...row.data.data
                };
            });
            this.sourceSendTenders.search({movements: rowsToSearch, payee_id: this.payee_id, is_auto: false})
        }
    }

    textboxTenderOverrideOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            if (!(this.textboxMustRespondBy.validateSimple() && this.textboxAddContact.validateSimple() && this.textboxContact.validateSimple())) {
                this.sendSelectedButton.enabled = false;
            }
            else {
                this.sendSelectedButton.enabled = true;
                const rowsToSearch = this.tableMultiSendLoadTender.allRows.map(row => {
                    return {
                        ...row.data.data
                    };
                });
                let contacts = this.sourceMultiSendTenders.activeRow?.get("contact", "");
                if (!StringUtil.isEmptyString(this.sourceMultiSendTenders.activeRow?.getString("additional_contacts", ""))) {
                    contacts = !StringUtil.isEmptyString(contacts) ? contacts + ", " + this.sourceMultiSendTenders.activeRow?.getString("additional_contacts", "") :
                     this.sourceMultiSendTenders.activeRow?.getString("additional_contacts", "");
                }
                this.sourceMultiPrepareTender.search({ movements: rowsToSearch, payee_id: this.payee_id,
                    contacts: contacts, must_respond_by: this.sourceMultiSendTenders.activeRow?.get("must_respond_by")});
            }
        }
    }
}
